import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import moment from 'moment';
import CustomTooltip from '../../utils/CustomTooltip';
import { globalClasses } from '../../utils/globalUtils';
import { classes } from './utils';
import DateTimePickersEditor from './DateTimePickerEditor';
import CellEditor from './CellEditor';

const getClassName = ({
  edited,
  fieldsData,
  changeData,
  idOfData,
  idOfVersion,
  editing,
}) => {
  let className = classes.typographyField;
  if (changeData && changeData.length > 0) {
    if (edited) {
      if (
        changeData.some(
          (item) => item.id === idOfData && item.value === fieldsData,
        )
      ) {
        className += ` ${classes.validateCheckIcon}`;
      } else {
        className += ` ${classes.editModeCheckIcon}`;
      }
    } else if (
      changeData.some(
        (item) => item.id === idOfData && item.value === fieldsData,
      )
    ) {
      className += ` ${classes.validateCheckIcon}`;
    } else {
      className += ` ${classes.sidebarTypographyColor}`;
    }

    if (idOfVersion !== '' && editing === null) {
      className += ` ${classes.cursorDisableClass}`;
    } else {
      className += ` ${globalClasses.cursorPointerClass}`;
    }
  }

  return className;
};
const ResponsiveFontsize = (params) => {
  if (params?.data) {
    const { colDef, mergedData, isEdited, changedData, versionId, isEditing } =
      params;
    const [id, setId] = useState('');
    if (
      params?.data[colDef.title] &&
      params?.data[colDef.title].value !== undefined &&
      params?.data[colDef.title].value !== null
    ) {
      let displayMessage = params?.data[colDef.title].value;
      if (colDef.title === 'Description') {
        const message = params?.data[colDef.title].value;
        displayMessage =
          message.length > 30 ? `${message.slice(0, 25)}.....` : message;
      }
      useEffect(() => {
        if (mergedData && mergedData.length > 0) {
          mergedData.forEach((d) => {
            if (
              d.product &&
              d.product === params?.data[colDef.title]?.product &&
              d.label === colDef.title &&
              d.id === params?.data[colDef.title]?.id
            ) {
              setId(d.id);
            }
          });
        }
      }, []);
      return (
        <CustomTooltip title={params?.data[colDef.title].value}>
          <Typography
            className={getClassName({
              edited: isEdited,
              fieldsData: params?.data[colDef.title].value,
              changeData: changedData,
              idOfData: id,
              idOfVersion: versionId,
              editing: isEditing,
            })}
            variant="body1"
          >
            {displayMessage}
          </Typography>
        </CustomTooltip>
      );
    }
    return <Typography variant="body1">-</Typography>;
  }
};
const memberDate = (params) => {
  const { colDef, mergedData, isEdited, changedData, versionId, isEditing } =
    params;
  const [id, setId] = useState('');
  if (params?.data) {
    const value =
      params?.data[colDef.title] && params?.data[colDef.title].value;
    let formattedDate = '-';
    if (value) {
      const [datePart, timePart] = value.split(' ');

      const normalizedDate = /[a-zA-Z]/.test(datePart)
        ? datePart
        : datePart.replace(/[-\\/]/g, '.');
      const dateFormats = [
        'DD.MM.YYYY',
        'MM.DD.YYYY',
        'DD.MM.YY',
        'MM.DD.YY',
        'DD-MMM-YYYY',
        'MMM-DD-YYYY',
        'YYYY-MMM-DD',
      ];
      const convertedDate = moment(normalizedDate, dateFormats, true).format(
        'YYYY-MM-DD',
      );

      if (convertedDate !== 'Invalid date') {
        const finalDateTime = timePart
          ? `${convertedDate} ${timePart}`
          : `${convertedDate} 00:00:00`;

        formattedDate = moment
          .utc(finalDateTime)
          .local()
          .format('DD-MM-YYYY HH:mm:ss');
      }
    }

    useEffect(() => {
      if (mergedData && mergedData.length > 0) {
        mergedData.forEach((d) => {
          if (
            d.product &&
            d.product === params?.data[colDef.title].product &&
            d.label === colDef.title &&
            d.id === params?.data[colDef.title].id
          ) {
            setId(d.id);
          }
        });
      }
    }, []);
    return (
      <Box>
        {value ? (
          <Typography
            className={getClassName({
              edited: isEdited,
              fieldsData: params?.data[colDef.title].value,
              changeData: changedData,
              idOfData: id,
              idOfVersion: versionId,
              editing: isEditing,
            })}
            variant="body1"
          >
            {formattedDate}
          </Typography>
        ) : (
          <Box>
            <Typography>-</Typography>
          </Box>
        )}
      </Box>
    );
  }
};

const generateDynamicColumns = (
  gridSettingData,
  gridKey,
  customFilterValue,
  transactionData,
  mergedData,
  updateOpenedData,
  selectedVersion,
  changedData,
  versionId,
  isEditing,
  setIsEdited,
  isEdited,
) =>
  transactionData &&
  transactionData.length > 0 &&
  transactionData.map((column) => {
    const columnDef = {
      headerName: column.short_desc,
      field: column.annotation_field.toLowerCase().replace(/\s+/g, '_'), // assuming fields are in snake_case based on header names
      headerComponent: 'ResponsiveSortingHeader',
      title: column.annotation_field,
      headerComponentParams: {
        gridSettingData,
        gridKey,
        customFilterValue,
      },
      sortable: false,
      filter: false,
      minWidth: column.annotation_field === 'Description' ? 300 : 100,
      maxWidth: column.annotation_field === 'Description' ? 400 : 250,
      cellRenderer: (params) =>
        column.annotation_field === 'Date'
          ? memberDate({
              ...params,
              mergedData,
              updateOpenedData,
              selectedVersion,
              changedData,
              versionId,
              isEditing,
            })
          : ResponsiveFontsize({
              ...params,
              mergedData,
              updateOpenedData,
              selectedVersion,
              setIsEdited,
              isEdited,
              changedData,
              versionId,
              isEditing,
            }),
      editable: true,
      cellEditor:
        column.annotation_field === 'Date' ? DateTimePickersEditor : CellEditor,
      cellEditorParams: {
        mergedData,
        updateOpenedData,
        selectedVersion,
        setIsEdited,
        isEdited,
        changedData,
        versionId,
        isEditing,
      },
    };

    return columnDef;
  });

const transactionColumnDef = (
  gridSettingData,
  gridKey,
  customFilterValue,
  transactionData,
  mapData,
  updateOpenedData,
  selectedVersion,
  changedData,
  versionId,
  isEditing,
  setIsEdited,
  isEdited,
) => {
  const mergedData = mapData;
  if (transactionData && transactionData.length > 0) {
    const showSelectedColumn = transactionData.filter((ele) => ele.status);
    return generateDynamicColumns(
      gridSettingData,
      gridKey,
      customFilterValue,
      showSelectedColumn,
      mergedData,
      updateOpenedData,
      selectedVersion,
      changedData,
      versionId,
      isEditing,
      setIsEdited,
      isEdited,
    );
  }

  return [];
};

export default transactionColumnDef;
